import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosInstance from "../../../Config/AxiosInstance";
import APILIST from "../../../Config/ApiList";
export const GET_LANGUAGE_ACTION = createAsyncThunk('/language/get_all', async (skip, limit) => {
  try {
    const response = await AxiosInstance.get(APILIST.GET_ALL_LANGUAGE, {
      params: {
        from: "languages",
        // arg: "role = 2 and status = 1"
      }
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
export const GET_HOURLY_RATE_REQUEST_ACTION = createAsyncThunk('/GET/LANGUAGE_HOURLY_RATE_REQUEST', async (userID) => {
  try {
    const response = await AxiosInstance.get(APILIST.GET_LANGUAGE_HOURLY_RATE_REQUEST);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
export const POST_HOURLY_RATE_REQUEST_ACTION = createAsyncThunk('/POST/LANGUAGE_HOURLY_RATE_REQUEST', async ({ id, status }) => {
  try {
    const formData = new FormData();
    formData.append("rate_change_id", id);
    formData.append("status", status);
    const response = await AxiosInstance.post(APILIST.POST_LANGUAGE_HOURLY_RATE_REQUEST, formData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
// =======================LANGUAGE_APPROVE ===============
export const NEW_LANGUAGE_APPROVE = createAsyncThunk('/POST/NEW_LANGUAGE_APPROVE', async (formData) => {
  try {
    const response = await AxiosInstance.post(APILIST.POST_NEW_LANGUAGE_ACCEPT_REJECT_API, formData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
export const NEW_LANGUAGE_REJECT = createAsyncThunk('/POST/NEW_LANGUAGE_REJECT', async (formData) => {
  try {
    const response = await AxiosInstance.post(APILIST.POST_NEW_LANGUAGE_ACCEPT_REJECT_API, formData);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});
